import React, { useEffect } from 'react';
import AOS from 'aos';
import { Text, Flex, Wrapper, GatsbyImage } from './';

const Card = ({ data }) => {
  const { cardTitle, cardSubtitle, cardImage } = data || {};

  useEffect(() => {
    AOS.init({ duration: 1000 });
  });

  return (
    <Wrapper>
      <Flex justifyContent="center">
        <GatsbyImage
          src={cardImage?.sourceUrl}
          alt={cardImage?.altText}
          maxwidth="350px"
          width="100%"
          height="auto"
          data-aos="zoom-out"
        />
      </Flex>
      <Text color="grey.v3" textAlign="center" mt={4}>
        {cardSubtitle}
      </Text>
      <Text
        as="h2"
        textAlign="center"
        dangerouslySetInnerHTML={{ __html: cardTitle }}
        mt={48}
        mb={5}
      />
    </Wrapper>
  );
};

export default Card;
